'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = init;
function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var showMoreBtn = context.getElement('.' + context.className + '_Btn');

  showMoreBtn.addEventListener('click', function (e) {
    if (el.getAttribute('aria-expanded') === 'true') {
      el.setAttribute('aria-expanded', false);
    } else {
      el.setAttribute('aria-expanded', true);
    }
  });
}